import * as yup from "yup";

export const InspectorSchema = (num: number, len: number) =>
  yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().email("Invalid Email").required("Email is required"),
    phone: yup.string(),
    timeOfCall: yup.string().required("Time is required"),
  });

export const HomeOwnerSchema = (name: boolean, num: number, len: number) =>
  yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    phone: yup.string(),
    organizationOrIndividual: yup.string().required("This is required"),
    organization_name: name
      ? yup.string().required("Organization name is required")
      : yup.string(),

    message: yup.string(),
  });
